<template>
  <AlModal
    :open-modal="showModal"
    data-testid="capacity-plan-saved-modal"
    :config="config"
    @close-modal="continueAction"
    @close="continueAction"
  >
    <Localization :message="body" />
  </AlModal>
</template>

<script>
import { AlModal } from "@playvox/almendra-components";
import { Translator, Localization } from "@agyletime/wfm-vue-common";

export default {
  name: "EditedModal",
  mixins: [Translator],
  components: {
    AlModal,
    Localization,
  },
  props: {
    header: {
      type: String,
      default: "saved-modal-header",
    },
    body: {
      type: String,
      default: "saved-modal-content",
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    config() {
      return {
        header: this.translate(this.header),
        size: "sm",
        buttons: [
          {
            class: "is-small",
            label: this.translate("saved-modal-button-continue"),
            testId: "saved-modal-continue",
            command: () => {
              this.continueAction();
            },
          },
        ],
      };
    },
  },
  methods: {
    continueAction() {
      this.$emit("continue-modal");
    },
  },
};
</script>
